'use client'

import type { TextSize } from '@mntn-dev/ui-theme'
import type { PropsWithChildren } from 'react'
import { Text } from '../../text/text.tsx'
import {
  type SectionHeaderSize,
  useSectionHeaderContext,
} from './use-section-header.ts'

const sizeClassMap: Record<SectionHeaderSize, TextSize> = {
  sm: 'xs',
  md: 'sm',
  lg: 'base',
}

export const SectionHeaderSubtitle = ({ children }: PropsWithChildren) => {
  const { size } = useSectionHeaderContext()

  return (
    <Text as="h3" fontSize={sizeClassMap[size]} textColor="secondary">
      {children}
    </Text>
  )
}
